import { render } from "./upsertDocumentDialog.vue?vue&type=template&id=e0d3063e"
import script from "./upsertDocumentDialog.vue?vue&type=script&lang=js"
export * from "./upsertDocumentDialog.vue?vue&type=script&lang=js"

import "./upsertDocumentDialog.vue?vue&type=style&index=0&id=e0d3063e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__